// utils/cropUtils.js

export default function getCroppedImg(imageSrc, crop, aspect) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = "anonymous"; // ✅ critical fix
        image.src = imageSrc;            // ✅ must come after

        image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const width = crop.width;
            const height = crop.height;

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(
                image,
                crop.x,
                crop.y,
                crop.width,
                crop.height,
                0,
                0,
                width,
                height
            );

            canvas.toBlob((blob) => {
                resolve(blob);
            }, 'image/jpeg');
        };

        image.onerror = () => reject(new Error('Image failed to load'));
    });
}